'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.externalDefaultProps = exports.externalPropTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var externalPropTypes = exports.externalPropTypes = {
  externalProps: _propTypes2.default.shape({
    size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge'])
  })
};

var externalDefaultProps = exports.externalDefaultProps = {
  externalProps: {
    size: 'default'
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-card/dist/externalPropTypes.js
// module id = 51
// module chunks = 0